/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react';

import WifiDisableIcon from '@/assets/icons/SystemSettingsWifiDisable.svg';
import {fontSize, LAYOUT} from '@/constants/appStyle';
import {SYSTEM_SETTING} from '@/constants/messages';
import {FONT_SIZE as FontSize} from '@/constants/pcConstAppData';
import {newLineHtml} from '@/libs/htmlHelper';

// TODO need to change this into (generic component | pure component) of wifi system settings cause of same component style
function WifiUnavailable() {
  const WifiUnavailableStyle = css({
    height: `calc(${LAYOUT.heightResolution} - (${LAYOUT.bottomMenuHeight} + ${LAYOUT.topMenuHeight}))`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',

    p: {
      color: 'grey',
      margin: '20px',
      fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    },
  });

  return (
    <div css={WifiUnavailableStyle}>
      <img
        src={WifiDisableIcon}
        alt={WifiDisableIcon}
      />
      <p>{newLineHtml(SYSTEM_SETTING.WIFI.WIFI_UNAVAILABLE)}</p>
    </div>
  );
}
export default WifiUnavailable;
